export const dealToCard = deal => ({
  id: deal.id,
  is_deal: true,
  deal_id: deal.id,
  conversation_id: deal.conversation_id,
  // Para abrir a conversa: a rota e o restante do painel falam display_id, e
  // conversation_id acima é a chave da tabela.
  conversation_display_id: deal.conversation_display_id,
  status: deal.status === 'open' ? 'open' : 'resolved',
  labels: [],
  last_activity_at: Math.floor(new Date(deal.updated_at).getTime() / 1000),
  meta: {
    sender: {
      id: deal.contact?.id,
      name: deal.contact?.name,
      phone_number: deal.contact?.phone_number,
    },
    assignee: deal.assignee_id ? { id: deal.assignee_id } : null,
  },
  custom_attributes: {
    deal_title: deal.title,
    deal_value: deal.value,
    deal_paid_value: deal.paid_value,
    deal_status: deal.status,
    deal_stage_entered_at: deal.stage_entered_at,
    // Contadores do servidor: no modo deals a lista de tarefas não vem no
    // card (seriam 380 listas), só o resumo que o aviso precisa.
    crm_pending_tasks: deal.pending_tasks_count,
    crm_overdue_tasks: deal.overdue_tasks_count,
    crm_documents_count: deal.documents_count || 0,
  },
});
